module.exports = __webpack_public_path__ + "media/images/national-aegis-newspaper-0106-1841-red-cross-endicott-4fedf1a00e28f4074b70df6d501518a8.png";